import { useQuery } from "@tanstack/react-query";
import { getCategoriesForSelect } from "../../api/apiCategories";
import i18next from "i18next";

const useGetCategoriesForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["categoriesForSelect", i18next.language],
        queryFn: getCategoriesForSelect,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetCategoriesForSelect;
